import React from 'react';
import { showPricePerUnit } from '../../../Utils/CategoryPageUtils';
import { convertPrice, getCountry } from '../../../Utils/ForeignUtils';
import { InclTax } from '../../Product/ProductDetail/styled';
import {
  Discount,
  NewLandingPagePrice,
  ProductPriceNew,
  SpecialPriceStyle,
  StrikePriceNew,
  TotalAmountNew,
} from './styled';

function PriceSectionNew(props) {
  const { productData, userType, showNewLandingPageUI, isWrapperPdp } = props;

  const { symbol, price } = convertPrice(
    productData?.actual_web_price || productData?.price,
  );
  const { price: strikeprice } = convertPrice(productData?.strikeprice, true);
  const country = getCountry();
  const showPerPrice = showPricePerUnit(userType, productData?.pricePerUnit);
  return showNewLandingPageUI ? (
    <NewLandingPagePrice>
      <div className="priceFlex">
        <p className="discount">
          {'- '}
          {productData?.discountPercent}% OFF
        </p>
        <p className="price">
          {' '}
          {symbol}
          {price}
        </p>

        <p className="pricePerUnit">{productData?.pricePerUnit}</p>
      </div>
      <p className="strikePrice">
        M.R.P {symbol}
        <span className="strike">{strikeprice}</span>
        {showPerPrice ? (
          <span className="incTax">(incl. of all taxes)</span>
        ) : null}
      </p>
    </NewLandingPagePrice>
  ) : (
    <>
      {productData?.strikeprice > productData?.price && !isWrapperPdp ? (
        <SpecialPriceStyle>
          Special Price
          <span />
        </SpecialPriceStyle>
      ) : null}
      <ProductPriceNew>
        <div className="price">
          <TotalAmountNew perUnit={showPerPrice} isUAE={country === 'uae'}>
            {symbol}
            {price}
          </TotalAmountNew>
          {productData?.strikeprice > productData?.price && (
            <Discount perUnit={showPerPrice} className="span">
              {'- '}
              {productData?.discountPercent}% OFF
            </Discount>
          )}
          {showPerPrice ? (
            <div className="pricePerUnit">{productData?.pricePerUnit}</div>
          ) : null}
        </div>
        <div className="mainPriceContainer">
          {productData?.strikeprice > productData?.price && (
            <StrikePriceNew className="span">
              MRP {symbol}
              <span>{strikeprice}</span>
            </StrikePriceNew>
          )}
        </div>
        {showPerPrice ? <InclTax perUnit>(incl. of all taxes)</InclTax> : null}
      </ProductPriceNew>
    </>
  );
}

export default PriceSectionNew;
